import { Component, HostListener, Input, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { IBusinessCard } from '@interfaces';
import { TranslateService } from '@ngx-translate/core';
import { BusinessCardService, LanguageService } from '@services';
import { ApiResponse, IConfig } from '@shared';
import { DomEvent } from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { environment } from '@env/environment';
@Component({
  selector: 'app-template3',
  templateUrl: './template3.component.html',
  styleUrl: './template3.component.scss',
})
export class Template3Component {
  @Input() businessCardLoader: boolean = true;
  @Input() businessCardData: IBusinessCard = {
    indexId: '',
    userId: '',
    status: '',
    templateId: '',
    userName: '',
    templateName: '',
    slogan: '',
    cardUrl: '',
    clientPhoneNumber: '',
    name: '',
    company: '',
    description: '',
    email: '',
    wpNumber: '',
    tiktokUrl: '',
    webUrl: '',
    fbUrl: '',
    instaUrl: '',
    youtubeUrl: '',
    logo: '',
    profileImage: '',
    workGallary: [],
    recommendationGallary: [],
    createdAt: '',
    updatedAt: '',
    youtubeVideoUrl: '',
    businessTitle: '',
    businessDescription: '',
    lang: '',
  };
  // id!: string;
  isLoading = false;
  videoId!: SafeHtml;
  environment;
  links: (keyof IBusinessCard)[] = ['email', 'wpNumber', 'tiktokUrl', 'fbUrl', 'instaUrl', 'youtubeUrl', 'webUrl'];
  linkCount = 0;
  constructor(
    private _languageService: LanguageService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private businessCardService: BusinessCardService,
    private toast: ToastrService,
    private sanitizer: DomSanitizer,
  ) {
    this.environment = environment;
  }
  carasoul = true;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updatePerSlide();
  }

  ngOnInit(): void {
    // this.route.queryParamMap.subscribe((map: any) => {
    //   const { lang } = map.params;
    //   if (lang !== 'en') {
    //     document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    //   } else {
    //     document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
    //   }
    // });
    this.translate.use(this.businessCardData.lang);
    // this.id = this.route.snapshot.paramMap.get('businessCardId')!;
    this.updatePerSlide();
    this.getBusinessCard();
  }
  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange.businessCardData) {
      this.getBusinessCard();
    }
  }
  updatePerSlide() {
    if (window.innerWidth >= 576) {
      this.carasoul = true;
    } else {
      this.carasoul = false;
    }
  }
  getBusinessCard() {
    this.businessCardData.businessDescription = this.businessCardData.businessDescription.replace(/\r?\n/g, '<br />');
    this.businessCardData.description = this.businessCardData.description.replace(/\r?\n/g, '<br />');
    this.videoId = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${this.getVideoId(this.businessCardData.youtubeVideoUrl)!} `,
    );
    this.businessCardData.workGallary = this.businessCardData.workGallary.filter((a: string) => a);
    this.businessCardData.recommendationGallary = this.businessCardData.recommendationGallary.filter((a: string) => a);
    this.links.forEach((linkName: keyof IBusinessCard) => {
      if (this.businessCardData[linkName]) {
        this.linkCount++;
      }
    });
  }
  getVideoId(url: string) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  }
  scroll(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  workGallarySlideConfig: IConfig = {
    dots: false,
    indicator: true,
    grid: true,
    target: 'workGallary',
    responsive: {
      0: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 4,
      },
    },
  };
  recommendationGallarySlideConfig: IConfig = {
    dots: false,
    indicator: true,
    grid: true,
    target: 'recommendationGallary',
    responsive: {
      0: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 4,
      },
    },
  };

  getWhatsAppLink() {
    return this.businessCardData.wpNumber
      ? `https://api.whatsapp.com/send?phone=${this.businessCardData.wpNumber}`
      : `https://api.whatsapp.com/send?phone=${this.businessCardData.clientPhoneNumber}`;
  }
}
